import { getGTMId, getEnvironment } from '../config/gtm';

export const ANALYTICS_EVENTS = {
    REDIRECT_API_ERROR: 'redirect_api_error',
    REDIRECT_ELIGIBILITY_FAILURE: 'redirect_eligibility_failure',
    REDIRECT_INVALID_PATH: 'redirect_invalid_path',
    REDIRECT_SESSION_EXTENSION: 'redirect_session_extension',
    REDIRECT_SERVER_RURL: 'redirect_server_rurl',
    REDIRECT_GENERAL: 'redirect_general'
};


export const trackEvent = (eventData, additionalData = {}) => {
    const environment = getEnvironment();
    const currentUrl = window.location.href;
    const queryParams = new URLSearchParams(window.location.search);

    const defaultVar1 = queryParams.get('var1') || '';
    const defaultVar2 = queryParams.get('var2') || '';
    const defaultVar3 = queryParams.get('var3') || '';
    const defaultOrderNo = queryParams.get('orderNo') || '';

    const baseEventData = {
        event: 'eventTracking',
        eventCategory: eventData.eventCategory || '',
        eventAction: eventData.eventAction || '',
        eventLabel: eventData.eventLabel || '',
        leadId: eventData.leadId || '',
        customerId: eventData.customerId || '',
        lobSection1: eventData.lobSection1 !== undefined ? eventData.lobSection1 : defaultVar1,
        lobSection2: eventData.lobSection2 !== undefined ? eventData.lobSection2 : defaultVar2,
        lobSection3: eventData.lobSection3 !== undefined ? eventData.lobSection3 : defaultVar3,
        productId: eventData.productId || '',
        bookingId: eventData.bookingId || defaultOrderNo,
        coverAmount: eventData.coverAmount || '',
        paymentMode: eventData.paymentMode || '',
        transactionAmount: eventData.transactionAmount || '',
        transactionId: eventData.transactionId || '',
        environment: environment,
        currentUrl: currentUrl,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        ...additionalData
    };

    if (window.dataLayer) {
        window.dataLayer.push(baseEventData);
    }
    console.log('Analytics Event:', baseEventData);

    return baseEventData;
};


export const trackRedirectEvent = (eventType, additionalData = {}) => {
    const environment = getEnvironment();
    const currentUrl = window.location.href;
    const queryParams = new URLSearchParams(window.location.search);

    const baseEventData = {
        event: 'eventTracking',
        eventCategory: 'REDIRECT_TO_POLICYBAZAAR',
        eventAction: eventType,
        eventLabel: `redirect_to_policybazaar_${environment}`,
        leadId: additionalData.leadId || '',
        customerId: additionalData.customerId || '',
        lobSection1: additionalData.lobSection1 !== undefined ? additionalData.lobSection1 : (queryParams.get('orderNo') || ''),
        lobSection2: additionalData.lobSection2 !== undefined ? additionalData.lobSection2 : (additionalData.reason || additionalData.redirectReason || ''),
        lobSection3: additionalData.lobSection3 !== undefined ? additionalData.lobSection3 : (additionalData.sourceOfError || additionalData.apiEndpoint || ''),
        productId: additionalData.productId || '',
        bookingId: queryParams.get('orderNo'),
        coverAmount: additionalData.coverAmount || '',
        paymentMode: additionalData.paymentMode || '',
        transactionAmount: additionalData.transactionAmount || '',
        transactionId: additionalData.transactionId || '',
        environment: environment,
        currentUrl: currentUrl,
        redirectUrl: additionalData.redirectUrl || '',
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
    };

    if (window.dataLayer) {
        window.dataLayer.push(baseEventData);
    }
    console.log('Analytics Event:', baseEventData);

    return baseEventData;
};

export const initializeGTM = () => {
    const gtmId = getGTMId();

    if (!gtmId || gtmId.includes('PLACEHOLDER')) {
        console.warn('GTM ID not configured. Please update the GTM IDs in src/config/gtm.js');
        return;
    }

    window.dataLayer = window.dataLayer || [];

    const script = document.createElement('script');
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmId}');
  `;

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);

    document.head.appendChild(script);
    document.body.insertBefore(noscript, document.body.firstChild);

    console.log(`GTM initialized with ID: ${gtmId} for environment: ${getEnvironment()}`);
};


export const redirectWithAnalytics = (url, eventType, additionalData = {}) => {
    trackRedirectEvent(eventType, {
        redirectUrl: url,
        ...additionalData
    });
    window.location.href = url;
};

